import { List as ListMui, ListProps as ListPropsMui } from '@mui/material';
import React from 'react';

export type ListProps = ListPropsMui;

export const List = React.forwardRef(
  ({ ...rest }: ListProps, ref: React.ForwardedRef<HTMLUListElement>) => (
    <ListMui {...rest} ref={ref} />
  ),
);
